import { render } from "./List.vue?vue&type=template&id=72424fae&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=72424fae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72424fae"

export default script